import { arrayOf, string } from 'prop-types';

export const CollectiblesType = arrayOf(string);

export default CollectiblesType;
